import { CardContent, Card, Typography, Button } from "@mui/material";
import { Box, Stack } from "@mui/system";
import Logo from "assets/icons/logo_light_horisontal.png";

import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAsyncDispatch } from "shared/helpers/hooks/useAsyncDispatch";
import { emailRegex, requiredRules } from "shared/helpers/validators";
import TextInput from "shared/ui/TextInput";
import { ERequestStatus } from "store/enums/index.enum";
import { SendCodeForgotPassword} from "store/slicers/users";

interface IFormValues {
  email: string;
}

const ResetPasswordPage = () => {
  const dispatch = useAsyncDispatch();
  const navigate = useNavigate();
  const form = useForm<IFormValues>({
    defaultValues: {
      email: "",
    },
  });

  const onSubmit = async (data: IFormValues) => {
    const { meta } = await dispatch(SendCodeForgotPassword(data));
    if (meta.requestStatus !== ERequestStatus.FULFILLED) {
      return;
    }
    navigate("/verify-code", {
        state: { email: data.email },
    });
  };
  return (
    <Box
      component="main"
      sx={{
        height: "100vh",
        backgroundImage: `url(${require("assets/images/auth_bg.jpg")})`,
        backgroundSize: "cover",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <Card
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          p: { xs: 0, sm: 2 },
          width: { xs: "95%", md: "40%", lg: "35%", xl: "25%" },
        }}
      >
        <CardContent
          sx={{
            p: "20px",
            py: "100px",
            width: "100%",
            paddingTop: 2,
          }}
        >
          <Box
            sx={{
              display: "inline-flex",
              width: "100%",
              justifyContent: "center",
              height: 70,
              mb: 2,
            }}
          >
            <img src={Logo} alt="" />
          </Box>
          <div>
            <Stack spacing={1} sx={{ mb: 1 }}>
              <Typography variant="h6">Enter your email</Typography>
            </Stack>

            <form noValidate onSubmit={form.handleSubmit(onSubmit)}>
              <FormProvider {...form}>
                <Stack spacing={2}>
                  <TextInput<IFormValues>
                    label="Email Address"
                    name="email"
                    type="email"
                    rules={{
                      pattern: {
                        value: emailRegex,
                        message: "Please enter a valid email address",
                      },
                      ...requiredRules,
                    }}
                  />
                </Stack>

                <Button
                  fullWidth
                  size="large"
                  sx={{ mt: 3 }}
                  type="submit"
                  variant="contained"
                >
                  Submit
                </Button>
              </FormProvider>
            </form>
          </div>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ResetPasswordPage;
